import * as React from 'react';
import { UIText1, UIText2 } from '@cian/ui-kit';

import * as styles from './Author.css';
import { getQuotedText } from '../../../utils/text/getQoutedText';

interface IAuthorProps {
  contactsButton?: React.ReactNode;
  label: string;
  name: string;
}

export const Author = ({ name, label, contactsButton }: IAuthorProps) => {
  const nameWithQuotes = React.useMemo(() => {
    return getQuotedText(name);
  }, [name]);

  return (
    <div className={styles['footer']} data-testid="Author">
      <div className={styles['description']}>
        <UIText2 color="text-secondary-default">{label}</UIText2>
        <UIText1>{nameWithQuotes}</UIText1>
      </div>
      {contactsButton && <div className={styles['button']}>{contactsButton}</div>}
    </div>
  );
};
